const { useSelector } = require("react-redux");

export function useSlice(sliceName, selector) {
  const slice = useSelector((state) => state[sliceName] || {});
  return selector ? selector(slice) : slice;
}
